/**
 * Ryan O'Dowd
 * 2025-05-15
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import WalkthroughTooltip from 'react-native-walkthrough-tooltip';

const WalkthroughTooltipWrapper = (props: React.ComponentProps<typeof WalkthroughTooltip>) => {
  return (
    <WalkthroughTooltip
      placement={props.placement}
      isVisible={props.isVisible}
      onClose={props.onClose}
      closeOnChildInteraction={true}
      closeOnContentInteraction={false}
      allowChildInteraction={true}
      topAdjustment={props.topAdjustment}
      content={props.content}
      {...props}
    >
      {props.children}
    </WalkthroughTooltip>
  );
};

export default WalkthroughTooltipWrapper;
